import { Button } from "@instructure/ui";

const SectionButton = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      variant="text"
      color="secondary"
      textAlign="start"
      withBackground={false}
      size="small"
      display="block"
      themeOverride={{
        borderRadius: 0,
        borderStyle: "none",
        borderWidth: 0,
        padding: 0,
        secondaryHoverBackground: "transparent",
        secondaryGhostHoverBackground: "transparent",
        smallPaddingBottom: 0,
        smallPaddingTop: 0,
        smallPaddingHorizontal: 0,
      }}
    >
      {children}
    </Button>
  );
};

export default SectionButton;
